// Dropdown menu
function togglenav() {
  var element = document.querySelector(".dropdown-nav");
  var breadcrumb = document.querySelector(".breadcrumb");
  element.classList.toggle("dropdown-nav-show");
  breadcrumb.classList.toggle("invisible");
}

// Video
function hideElement(element) {
  element.style.display = 'none';

  var parent = element.parentNode;
  var videoBanner = parent.querySelector('.video-banner');
  var rolexVideo = parent.querySelector('.rolex-video');

  if (videoBanner && rolexVideo) {
    videoBanner.style.display = 'none';
    rolexVideo.style.display = 'block';
    rolexVideo.play();
  }
}